(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Türkçe normalize + eşanlamlı sözlük ---------- */
  var MAP = { 'ı':'i','ğ':'g','ü':'u','ş':'s','ö':'o','ç':'c','â':'a','î':'i','û':'u','İ':'i' };
  function norm(s) {
    return String(s || '').toLowerCase().replace(/[ığüşöçâîû]/g, function (c) { return MAP[c] || c; })
      .replace(/[-+.,'’]/g, ' ').replace(/\s+/g, ' ').trim();
  }
  var SYN = {
    'omega': 'omega 3 omega3 balik yagi fish oil epa dha trigliserid softgel yag',
    'magnesium': 'magnezyum mg sitrat citrate malat malate bisglisinat bisglycinate taurat taurate b6 kas mineral quad',
    '5-htp': '5 htp htp serotonin rhodiola rodiola theanine teanin sari kantaron passiflora relax calm sakin',
    'lion': 'lions mane lion mane aslan yelesi mantar tirozin fosfatidilserin neuro beyin odak hafiza',
    'testo': 'testosteron tribulus maca ginseng saw palmetto ginkgo biloba arjinin arginine erkek men saponin',
    'dim': 'hormonal detoks detox glukarat indol selenyum selenium yesil cay alfa lipoik',
    'bromelain': 'enzim enzyme glukomannan krom chrome pikolinat kuersetin quercetin ananas metabolizma',
    'd3': 'd 3 d vitamini vitamin d k2 mk 7 mk7 menakinon koenzim q10 q10 kemik gunes platinium',
    'glucosamine': 'glukozamin eklem joint kondroitin chondroitin msm akgunluk boswellia zerdecal kurkumin kikirdak',
    'multivit': 'multivitamin multi coklu vitamin 28 gunluk daily vitamin mineral',
    'vita-c': 'c vitamini vitamin c vita c askorbik ascorbic beta glukan kara murver elderberry resveratrol kuersetin ginseng cinko zinc bagisiklik guard',
    'berberine': 'berberin berberis vulgaris glukoz glucose insulin alfa lipoik fosfatidilkolin inulin krom forte',
    'b12': 'b 12 metilkobalamin methylcobalamin kobalamin folik asit folat b6 cignenebilir chewable cilek yorgunluk enerji methyl'
  };

  var INDEX = null;
  function index() {
    if (INDEX) return INDEX;
    var el = $('[data-search-index]');
    if (!el) return (INDEX = []);
    try { INDEX = JSON.parse(el.textContent); } catch (e) { INDEX = []; }
    INDEX.forEach(function (p) {
      var extra = '';
      var nt = norm(p.t);
      for (var key in SYN) if (nt.indexOf(norm(key)) >= 0) extra += ' ' + SYN[key];
      p._hay = norm([p.t, p.g, p.f, p.c, p.k].join(' ') + extra);
    });
    return INDEX;
  }

  function money(v) { return v; }

  function renderResults(list, head) {
    var box = $('[data-search-results]');
    if (!box) return;
    $('[data-search-head]').textContent = head;
    $('[data-search-empty]').hidden = list.length > 0;
    box.innerHTML = list.map(function (p) {
      return '<a class="res" href="' + p.h + '" style="--accent:' + p.a + '">' +
        (p.i ? '<img class="res__img" src="' + p.i + '" alt="" width="54" height="54">' : '<span class="res__img"></span>') +
        '<span class="res__mid">' +
          '<span class="res__cat">' + (p.c || '').toLocaleUpperCase('tr') + '</span>' +
          '<span class="res__name">' + p.t + '</span>' +
          '<span class="res__sub">' + [p.g, p.f].filter(Boolean).join(' · ') + '</span>' +
        '</span>' +
        '<span class="res__right">' +
          '<span class="res__price">' + money(p.p) + '</span>' +
          (p.ok === false
            ? '<span class="res__out">TÜKENDİ</span>'
            : '<button class="res__add" data-add="' + p.v + '">EKLE</button>') +
        '</span>' +
      '</a>';
    }).join('');
  }

  function search(q) {
    var list = index();
    var n = norm(q);
    if (!n) { renderResults(list.slice(0, 4), 'ÖNE ÇIKAN FORMÜLLER'); return; }
    var hits = list.map(function (p) { return { p: p, at: p._hay.indexOf(n) }; })
      .filter(function (o) { return o.at >= 0; })
      .sort(function (a, b) { return a.at - b.at; })
      .map(function (o) { return o.p; });
    renderResults(hits, hits.length + ' sonuç · “' + q.trim() + '”');
  }

  /* ---------- overlay + drawer ---------- */
  function openSearch() {
    var ov = $('[data-search-overlay]'); if (!ov) return;
    ov.hidden = false; document.body.style.overflow = 'hidden';
    search('');
    var inp = $('[data-search-input]'); if (inp) { inp.value = ''; inp.focus(); }
  }
  function openGoal(handles, label) {
    var ov = $('[data-search-overlay]'); if (!ov) return;
    var want = String(handles || '').split(',').map(function (h) { return h.trim(); }).filter(Boolean);
    var list = index();
    var picked = want.map(function (h) {
      for (var i = 0; i < list.length; i++) if (list[i].s === h) return list[i];
      return null;
    }).filter(Boolean);
    ov.hidden = false; document.body.style.overflow = 'hidden';
    var inp = $('[data-search-input]'); if (inp) inp.value = '';
    if (picked.length) renderResults(picked, 'AMAÇ: ' + String(label || '').toLocaleUpperCase('tr'));
    else search('');
    if (inp) inp.focus();
  }
  function closeAll() {
    var ov = $('[data-search-overlay]'), dr = $('[data-cart-drawer]');
    if (ov) ov.hidden = true;
    if (dr) dr.hidden = true;
    document.body.style.overflow = '';
  }
  function openCart() {
    var dr = $('[data-cart-drawer]'); if (!dr) return;
    dr.hidden = false; document.body.style.overflow = 'hidden';
  }

  /* ---------- sepet ---------- */
  function refreshCart() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + '?sections=cart-drawer' : '/?sections=cart-drawer')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (data && data['cart-drawer']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = data['cart-drawer'];
          var fresh = $('[data-cart-body]', tmp), host = $('[data-cart-body]');
          if (fresh && host) host.innerHTML = fresh.innerHTML;
        }
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (c) { if (c) $$('[data-cart-count]').forEach(function (e) { e.textContent = c.item_count; }); })
      .catch(function () { location.href = '/cart'; });
  }

  function addToCart(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    }).then(function () { closeAll(); openCart(); return refreshCart(); });
  }

  function changeLine(line, to) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(to) })
    }).then(function () {
      if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
      return refreshCart();
    });
  }

  /* ---------- olaylar ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var hit = function (sel) { return t.closest && t.closest(sel); };

    if (hit('[data-open-search]')) { e.preventDefault(); openSearch(); return; }
    var goal = hit('[data-goal]');
    if (goal) { e.preventDefault(); openGoal(goal.getAttribute('data-goal'), goal.getAttribute('data-goal-label')); return; }
    if (hit('[data-close-search]') || hit('[data-close-cart]')) { e.preventDefault(); closeAll(); return; }
    if (hit('[data-open-cart]')) { e.preventDefault(); closeAll(); openCart(); return; }

    var ov = $('[data-search-overlay]');
    if (ov && !ov.hidden && t === ov) { closeAll(); return; }
    var dr = $('[data-cart-drawer]');
    if (dr && !dr.hidden && t === dr) { closeAll(); return; }

    var add = hit('[data-add]');
    if (add) { e.preventDefault(); add.disabled = true; addToCart(add.getAttribute('data-add'), 1).then(function(){ add.disabled = false; }); return; }

    var pick = hit('[data-hero-pick]');
    if (pick && window.__heroGo && window.__heroIndex) {
      var pi = window.__heroIndex[pick.getAttribute('data-hero-pick')];
      if (pi != null) {
        e.preventDefault();
        var heroEl = $('[data-hero]');
        var far = 0;
        if (heroEl) {
          var hdr = $('[data-header]');
          var off = (hdr ? hdr.getBoundingClientRect().height : 90) + 12;
          var yNow = window.pageYOffset || document.documentElement.scrollTop || 0;
          var yTo = Math.max(0, heroEl.getBoundingClientRect().top + yNow - off);
          far = Math.abs(yNow - yTo);
          if (far > 8) {
            try { window.scrollTo({ top: yTo, behavior: 'smooth' }); } catch (err) { window.scrollTo(0, yTo); }
          }
        }
        if (far > 500) setTimeout(function () { window.__heroGo(pi); }, 400);
        else window.__heroGo(pi);
        return;
      }
    }

    var q = hit('[data-qty-change]');
    if (q) { e.preventDefault(); changeLine(q.getAttribute('data-line'), q.getAttribute('data-to')); return; }

    var ft = hit('[data-formula-toggle]');
    if (ft) {
      e.preventDefault();
      var mp = $('[data-formula-panel]');
      if (mp) {
        var willOpen = mp.hidden;
        mp.hidden = !willOpen;
        var mm = $('[data-mobile-menu]');
        if (mm && willOpen) {
          mm.hidden = true;
          var bt = $('[data-menu-toggle]');
          if (bt) bt.setAttribute('aria-expanded', 'false');
        }
        document.documentElement.style.overflow = (willOpen && window.innerWidth <= 760) ? 'hidden' : '';
        var all = document.querySelectorAll('[data-formula-toggle]');
        for (var i = 0; i < all.length; i++) {
          all[i].setAttribute('aria-expanded', String(willOpen));
          all[i].classList.toggle('is-on', willOpen);
        }
      }
      return;
    }
    if (!hit('[data-formula-panel]') && !hit('[data-header]')) closeFormulaPanel();

    var burger = hit('[data-menu-toggle]');
    if (burger) {
      var m = $('[data-mobile-menu]');
      if (m) { m.hidden = !m.hidden; burger.setAttribute('aria-expanded', String(!m.hidden)); }
      return;
    }
  });

  document.addEventListener('input', function (e) {
    if (e.target.matches('[data-search-input]')) search(e.target.value);
    if (e.target.matches('[data-nl-consent]')) {
      var btn = $('[data-nl-submit]'); if (btn) btn.disabled = !e.target.checked;
    }
  });

  function closeFormulaPanel() {
    var mp = $('[data-formula-panel]');
    if (!mp || mp.hidden) return;
    mp.hidden = true;
    document.documentElement.style.overflow = '';
    var all = document.querySelectorAll('[data-formula-toggle]');
    for (var i = 0; i < all.length; i++) {
      all[i].setAttribute('aria-expanded', 'false');
      all[i].classList.remove('is-on');
    }
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeFormulaPanel(); closeAll(); }
    else if ((e.key === 'k' || e.key === 'K') && (e.metaKey || e.ctrlKey)) { e.preventDefault(); openSearch(); }
  });

  /* ürün formundan sepete ekleme */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    var who = e.submitter || (document.activeElement && document.activeElement.form === form ? document.activeElement : null);
    if (who && who.name === 'checkout') return;   /* Hemen Al → doğrudan ödemeye gider */
    e.preventDefault();
    var fd = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(function () { closeAll(); openCart(); return refreshCart(); });
  });
})();

/* ---------- vitrin karuseli, şeritler, ürün sayfası ---------- */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* sürükleyerek kaydırılan şeritler */
  $$('[data-rail]').forEach(function (rail) {
    var down = false, sx = 0, sl = 0, moved = 0;
    rail.addEventListener('dragstart', function (e) { e.preventDefault(); });
    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      down = true; moved = 0; sx = e.clientX; sl = rail.scrollLeft;
      rail.style.cursor = 'grabbing';
      if (e.target && e.target.closest && e.target.closest('a')) e.preventDefault();
    });
    rail.addEventListener('pointermove', function (e) {
      if (!down) return;
      var d = e.clientX - sx;
      moved = Math.max(moved, Math.abs(d));
      rail.scrollLeft = sl - d;
    });
    ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (ev) {
      rail.addEventListener(ev, function () { down = false; rail.style.cursor = ''; });
    });
    rail.addEventListener('click', function (e) {
      if (moved > 6) { e.preventDefault(); e.stopPropagation(); }
      moved = 0;
    }, true);
  });

  /* vitrin karuseli */
  var hero = $('[data-hero]');
  if (hero) {
    var slides = $$('[data-hero-slide]', hero);
    var pips = $$('[data-hero-pip]', hero);
    var cur = 0, timer = null;
    var fadeMs = function () {
      var raw = (getComputedStyle(hero).getPropertyValue('--fade') || '').trim();
      var n = parseFloat(raw) || 300;
      if (/ms/.test(raw) || n > 20) return n;
      return n * 1000;
    };
    var swap = function (n) {
      cur = n;
      slides.forEach(function (s, k) {
        s.hidden = false;
        s.classList.toggle('is-on', k === cur);
      });
      pips.forEach(function (p, k) { p.classList.toggle('is-on', k === cur); });
      var slug = slides[cur] ? slides[cur].getAttribute('data-handle') : '';
      var ac = slides[cur] ? (slides[cur].style.getPropertyValue('--accent') || '').trim() : '';
      var hd = $('[data-header]');
      if (hd && ac) hd.style.setProperty('--accent', ac);
      $$('[data-hero-pick]').forEach(function (el) {
        var host = el.closest('.pcard, .row');
        if (host) host.classList.toggle('is-active', el.getAttribute('data-hero-pick') === slug);
      });
    };
    var go = function (i, instant) {
      if (!slides.length) return;
      var next = (i + slides.length) % slides.length;
      if (instant) { swap(next); clearTimeout(timer); timer = null; hero.classList.remove('is-fading'); return; }
      if (next === cur && !timer) return;
      clearTimeout(timer);
      hero.classList.add('is-fading');
      timer = setTimeout(function () {
        var incoming = slides[next];
        if (incoming) incoming.classList.add('is-in');
        swap(next);
        hero.classList.remove('is-fading');
        void hero.offsetWidth;
        if (incoming) incoming.classList.remove('is-in');
        timer = null;
      }, fadeMs());
    };
    window.__heroGo = go;
    window.__heroIndex = {};
    slides.forEach(function (s, n) {
      var h = s.getAttribute('data-handle');
      if (h) window.__heroIndex[h] = n;
    });
    go(0, true);
    hero.addEventListener('click', function (e) {
      var pip = e.target.closest('[data-hero-pip]');
      if (pip) { go(Number(pip.getAttribute('data-hero-pip'))); return; }
      if (e.target.closest('[data-hero-next]')) { go(cur + 1); return; }
      if (e.target.closest('[data-hero-prev]')) { go(cur - 1); return; }
    });
  }

  /* sırayı formül numarasına göre diz */  $$('[data-sort-seq]').forEach(function (box) {
    var kids = [], tail = [];
    Array.prototype.slice.call(box.children).forEach(function (c) {
      if (c.hasAttribute('data-seq')) kids.push(c); else tail.push(c);
    });
    if (kids.length < 2) return;
    kids.sort(function (a, b) {
      return String(a.getAttribute('data-seq')).localeCompare(String(b.getAttribute('data-seq')), 'tr', { numeric: true });
    });
    kids.forEach(function (k) { box.appendChild(k); });
    tail.forEach(function (t) { box.appendChild(t); });
  });

  /* ürün görsel küçükleri */
  document.addEventListener('click', function (e) {
    var th = e.target.closest('[data-pdp-thumb]');
    if (!th) return;
    var main = $('#pdp-main');
    if (main) main.src = th.getAttribute('data-pdp-thumb');
    $$('[data-pdp-thumb]').forEach(function (b) { b.classList.toggle('is-on', b === th); });
  });

  /* adet sayacı */
  document.addEventListener('click', function (e) {
    var up = e.target.closest('[data-qty-up]'), dn = e.target.closest('[data-qty-down]');
    if (!up && !dn) return;
    var box = (up || dn).closest('[data-stepper]');
    var out = $('[data-qty-val]', box);
    var form = box.closest('form');
    var inp = form && $('[data-qty-input]', form);
    var v = Math.max(1, Number(out.textContent || 1) + (up ? 1 : -1));
    out.textContent = v;
    if (inp) inp.value = v;
  });

  /* varyant seçimi — stok ve fiyat Shopify verisinden */
  (function () {
    var box = $('.pdp__variants');
    if (!box) return;
    var data = [];
    try { data = JSON.parse($('[data-variant-data]', box).textContent); } catch (e) { return; }
    var pdp = $('.pdp');
    var sel = $('[data-variant-select]', box);

    var chosen = function () {
      return $$('.pdp__opt', box).map(function (opt) {
        var on = $('input:checked', opt);
        return on ? on.value : null;
      });
    };

    /* seçili diğer opsiyonlarla birlikte bu değerin satılabilir varyantı var mı */
    var reachable = function (i, val, picks) {
      return data.some(function (v) {
        if (v.opts[i] !== val) return false;
        for (var k = 0; k < picks.length; k++) {
          if (k !== i && picks[k] && v.opts[k] !== picks[k]) return false;
        }
        return v.ok;
      });
    };

    var sync = function () {
      var picks = chosen();

      $$('.pdp__val', box).forEach(function (l) {
        var i = Number(l.getAttribute('data-opt'));
        var val = l.getAttribute('data-val');
        l.classList.toggle('is-on', !!$('input:checked', l));
        l.classList.toggle('is-off', !reachable(i, val, picks));
      });

      var hit = data.filter(function (v) {
        return picks.every(function (p, i) { return !p || v.opts[i] === p; });
      })[0];
      if (!hit) return;

      if (sel) sel.value = hit.id;
      var idInp = pdp && $('[data-variant-id]', pdp);
      if (idInp) idInp.value = hit.id;

      var price = pdp && $('[data-price]', pdp);
      if (price) price.textContent = hit.price;

      var was = pdp && $('[data-compare]', pdp);
      if (was) { was.textContent = hit.was; was.hidden = !hit.hasWas; }

      var stock = pdp && $('[data-stock]', pdp);
      if (stock) {
        if (!hit.ok) stock.innerHTML = '<b class="stock stock--out">tükendi</b>';
        else if (hit.left !== null && hit.left > 0 && hit.left <= 5) stock.innerHTML = '<b class="stock stock--low">son ' + hit.left + ' adet</b>';
        else stock.textContent = 'stokta';
      }

      $$('.pdp__form [type="submit"]', pdp || document).forEach(function (b) {
        b.disabled = !hit.ok;
        if (b.name === 'add') b.textContent = hit.ok ? 'Sepete Ekle' : 'Tükendi';
      });

      if (history.replaceState) {
        history.replaceState({}, '', location.pathname + '?variant=' + hit.id);
      }
    };

    box.addEventListener('change', function (e) {
      if (e.target.matches('.pdp__val input')) sync();
    });
    sync();
  })();
})();

/* ---------- sahne: şişe ↔ bileşen orbiti (ürün sayfası + vitrin) ---------- */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;

  function initStage(stage) {
    var ring = $('[data-orb-ring]', stage);
    if (!ring) return;

    var panel = $('[data-stage-panel]', stage);
    var pTitle = $('[data-panel-title]', stage);
    var pText = $('[data-panel-text]', stage);
    var hint = $('[data-stage-hint]', stage);
    var closedTxt = hint ? hint.textContent.trim() : '';
    var openTxt = stage.getAttribute('data-hint-open') || 'SÜRÜKLEYEREK ÇEVİRİN';
    var coarse = !(window.matchMedia && window.matchMedia('(pointer:fine)').matches);
    if (coarse) {
      closedTxt = stage.getAttribute('data-hint-touch') || 'FORMÜLÜ GÖRMEK İÇİN ÜRÜNE DOKUNUN';
      openTxt = stage.getAttribute('data-hint-open-touch') || 'ÇEVİRMEK İÇİN PARMAĞINIZLA SÜRÜKLEYİN';
      if (hint && hint.textContent.trim()) hint.textContent = closedTxt;
    }
    var nodes = $$('[data-orb-node]', ring);
    var slots = $$('[data-orb-inner]', ring);
    var bases = slots.map(function (s) {
      var m = /rotate\(([-0-9.]+)deg\)/.exec(s.parentNode.style.transform || '');
      return m ? parseFloat(m[1]) : 0;
    });
    var rot = 0, open = false, moved = false;

    /* bileşen sayısına göre madalyon ölçüsü — kalabalık orbitte küçülür */
    if (nodes.length > 8) stage.style.setProperty('--disc', 'clamp(38px,8vw,52px)');
    if (nodes.length > 10) stage.style.setProperty('--disc', 'clamp(34px,7vw,46px)');

    var applyRot = function () {
      ring.style.setProperty('--rot', rot + 'deg');
      slots.forEach(function (s, k) {
        s.style.transform = 'translate(-50%,-50%) rotate(' + (-(bases[k] + rot)) + 'deg)';
      });
    };

    var hidePanel = function () {
      if (panel) panel.hidden = true;
      nodes.forEach(function (b) { b.classList.remove('is-on'); });
    };
    var showPanel = function (btn) {
      if (!panel) return;
      nodes.forEach(function (b) { b.classList.toggle('is-on', b === btn); });
      pTitle.textContent = btn.getAttribute('data-label') || '';
      var note = (btn.getAttribute('data-note') || '').trim();
      pText.textContent = note || 'Bu formülün bileşenlerinden biri. Tam miktar içerik tablosunda yer alır.';
      panel.hidden = false;
    };
    var setOpen = function (on) {
      open = on;
      stage.classList.toggle('is-open', on);
      if (hint) hint.textContent = on ? openTxt : closedTxt;
      if (!on) hidePanel();
    };

    if (fine) {
      stage.addEventListener('pointerenter', function () { setOpen(true); });
      stage.addEventListener('pointerleave', function () { setOpen(false); });
    }
    stage.addEventListener('focus', function () { setOpen(true); });
    stage.addEventListener('blur', function () { setOpen(false); });
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setOpen(!open); }
      if (e.key === 'Escape') setOpen(false);
    });
    stage.addEventListener('click', function (e) {
      if (e.target.closest('[data-orb-node]')) return;
      if (moved) { moved = false; return; }
      if (!fine) setOpen(!open);
    });

    ring.addEventListener('pointerover', function (e) {
      var b = e.target.closest('[data-orb-node]');
      if (b && fine) showPanel(b);
    });
    ring.addEventListener('pointerout', function (e) {
      var b = e.target.closest('[data-orb-node]');
      if (b && fine && !moved) hidePanel();
    });
    ring.addEventListener('click', function (e) {
      var b = e.target.closest('[data-orb-node]');
      if (!b) return;
      e.preventDefault();
      e.stopPropagation();
      if (moved) { moved = false; return; }
      if (b.classList.contains('is-on')) hidePanel(); else showPanel(b);
    });

    var drag = false, startAng = 0, startRot = 0;
    var angleOf = function (e) {
      var r = ring.getBoundingClientRect();
      return Math.atan2(e.clientY - (r.top + r.height / 2), e.clientX - (r.left + r.width / 2)) * 180 / Math.PI;
    };
    ring.addEventListener('pointerdown', function (e) {
      if (!open) return;
      drag = true; moved = false;
      startAng = angleOf(e); startRot = rot;
      if (ring.setPointerCapture) ring.setPointerCapture(e.pointerId);
    });
    ring.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var d = angleOf(e) - startAng;
      if (Math.abs(d) > 2) moved = true;
      rot = startRot + d;
      applyRot();
    });
    ['pointerup', 'pointercancel'].forEach(function (ev) {
      ring.addEventListener(ev, function () { drag = false; });
    });

    applyRot();
  }

  $$('[data-stage].has-orbit').forEach(initStage);

  /* hikâye sahneleri — kaydırınca belirir */
  (function () {
    var scenes = document.querySelectorAll('[data-story-scene]');
    if (!scenes.length) return;
    if (!('IntersectionObserver' in window)) {
      for (var j = 0; j < scenes.length; j++) scenes[j].classList.add('is-in');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.18 });
    for (var i = 0; i < scenes.length; i++) io.observe(scenes[i]);
  })();

})();